(function () {
    'use strict';

    angular
        .module('corporateRoleEditRoutes', [
            'corporateRoleEditModule',
            'corporateRoleModule'
        ])
        .config(router);

    router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, historyCtxtServiceProvider) {

        $stateProvider

              // CorporateRole Add
              .state('corporateRoleAdd', {
                  url: '/CorporateRole/Add',
                  templateUrl: require('./CorporateRoleAdd.tpl.html'),
                  controller: 'CorporateRoleAddController'
              })

             // CorporateRole Not Exists
             .state('corporateRoleNotExists', {
                 url: '/CorporateRole/{CorporateRoleID:int}/NotExists',
                 templateUrl: require('./corporateRoleNotExists.tpl.html')
             })

             // CorporateRole Edit
             .state('corporateRole', {
                 url: '/CorporateRole/{CorporateRoleID:int}',
                 params: historyCtxtServiceProvider.getStateParamsConfig(),
                 resolve: {
                     corporateRole: ['$stateParams', 'corporateRoleService', function ($stateParams, service) {
                         return service.getCorporateRole($stateParams.CorporateRoleID);
                     }],
                 },
                 views: {
                     '': {
                         template: '<div ui-view="mainContent"></div>',
                         controller: 'CorporateRoleEditController',
                     },
                     'mainContent@corporateRole': {
                         templateUrl: require('./CorporateRoleEdit.tpl.html')
                     }
                 }
             });

        // History Context
        historyCtxtServiceProvider.setCtxtState('corporateRole',
            '/app/Main/grcEdit/corporateRole/GOVHistoryCtxtDirective-corporateRole.tpl.html'
        );
    }
})();
